<template>
  <div>
    <v-row class="mb-2 align-center">
      <v-col cols="12" sm="6">
        <v-switch
          v-model="showAllFields"
          label="Alle Felder anzeigen"
          hide-details
          dense
          class="mt-0"
        />
      </v-col>
      <v-col cols="12" sm="6" class="text-sm-right">
        <span v-if="diffCount > 0" class="caption">
          <v-chip x-small color="amber lighten-4" class="mr-1">{{ diffCount }}</v-chip>
          {{ diffCount === 1 ? 'Unterschied' : 'Unterschiede' }}
        </span>
        <span v-else class="caption success--text">Keine Feldunterschiede</span>
      </v-col>
    </v-row>

    <div v-if="diffCount > 0" class="diff-legend caption mb-3">
      <span class="legend-item legend-different">Wert unterscheidet sich</span>
      <span class="legend-item legend-only-a">Nur in A</span>
      <span class="legend-item legend-only-b">Nur in B</span>
    </div>

    <v-simple-table dense class="diff-table">
      <thead>
        <tr>
          <th class="text-left field-col">Feld</th>
          <th class="text-left value-col">Datensatz A</th>
          <th class="text-left value-col">Datensatz B</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="visibleDiffs.length === 0">
          <td colspan="3" class="text-center grey--text py-4">
            Alle Felder sind identisch oder leer.
          </td>
        </tr>
        <tr
          v-for="row in visibleDiffs"
          :key="row.field"
          :class="rowClass(row.status)"
        >
          <td class="field-col font-weight-medium">{{ row.label }}</td>
          <td class="value-col" :class="cellClass(row.status, 'a')">
            {{ formatValue(row.valueA) }}
          </td>
          <td class="value-col" :class="cellClass(row.status, 'b')">
            {{ formatValue(row.valueB) }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    fieldDiffs: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    showAllFields: false
  }),
  computed: {
    diffCount () {
      return this.fieldDiffs.filter(row => row.status !== 'equal').length
    },
    visibleDiffs () {
      if (this.showAllFields) {
        return this.fieldDiffs
      }
      return this.fieldDiffs.filter(row => row.status !== 'equal')
    }
  },
  methods: {
    rowClass (status) {
      if (status === 'different') return 'diff-row-different'
      if (status === 'only_a') return 'diff-row-only-a'
      if (status === 'only_b') return 'diff-row-only-b'
      return 'diff-row-equal'
    },
    cellClass (status, side) {
      if (status === 'different') return 'cell-different'
      if (status === 'only_a' && side === 'a') return 'cell-only-a'
      if (status === 'only_b' && side === 'b') return 'cell-only-b'
      return ''
    },
    formatValue (value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      if (typeof value === 'boolean') {
        return value ? 'true' : 'false'
      }
      return String(value)
    }
  }
}
</script>

<style scoped>
.field-col {
  width: 22%;
  vertical-align: top;
}
.value-col {
  width: 39%;
  word-break: break-word;
  vertical-align: top;
}
.diff-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.legend-item {
  padding: 2px 8px;
  border-radius: 4px;
}
.legend-different {
  background-color: #fff3cd;
}
.legend-only-a {
  background-color: #ffe0b2;
}
.legend-only-b {
  background-color: #bbdefb;
}
</style>

<style>
/* v-simple-table rows live outside scoped element tree — global styles for diff highlighting */
.diff-table tbody tr.diff-row-different {
  background-color: #fff8e1 !important;
}
.diff-table tbody tr.diff-row-only-a {
  background-color: #fff3e0 !important;
}
.diff-table tbody tr.diff-row-only-b {
  background-color: #e3f2fd !important;
}
.diff-table tbody tr.diff-row-equal {
  background-color: transparent;
}
.diff-table tbody td.cell-different {
  font-weight: 600;
  color: #e65100;
}
.diff-table tbody td.cell-only-a {
  font-weight: 600;
  color: #ef6c00;
}
.diff-table tbody td.cell-only-b {
  font-weight: 600;
  color: #1565c0;
}
</style>
